
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 9 6"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"c"}},[_c('path',{attrs:{"d":"M0 0l4.5 3L0 6","id":"b"}})]),_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h9v6H0z"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M0 0v6h9V0z","fill":"#002395"}}),_c('path',{attrs:{"d":"M0 0v3h9V0z","fill":"#de3831"}}),_c('g',{attrs:{"stroke-width":"2","stroke":"#fff"}},[_c('path',{attrs:{"d":"M0 0l4.5 3L0 6m4.5-3H9","id":"d"}}),_c('use',{attrs:{"xlink:href":"#b","stroke":"#ffb612","clip-path":"url(#c)"}})]),_c('use',{attrs:{"xlink:href":"#d","fill":"none","stroke":"#007a4d","stroke-width":"1.2"}})])])
          )
        }
      }
    